import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi } from '@fortawesome/free-solid-svg-icons';
const Loader3 = ({
    txtInfo
    
}) => {
    const mystyle = {
        width:"70px",
        height:"70px",
        color: "#fff",
        background: "#B71C1C",
        borderRadius:"50px",
        textAlign:"center",
        position: "fixed",
        bottom: "1rem",
        left: "1rem",
        zIndex:"2000"
      };
      
    return (
        <div> 
            
            <div style={mystyle}>
            <span style={{fontWeight:"bold",fontSize:"14.6px"}}> <FontAwesomeIcon icon={faWifi} /> </span>
              <span style={{fontWeight:"bold",fontSize:"16.6px",lineHeight:".9rem",display:"flex",marginLeft:"1.1rem"}}>   {txtInfo}</span><span style={{fontWeight:"bold",fontSize:"14.6px"}}>Mb/s</span>
            </div>
        </div>
    )
}
export default Loader3